<template>
  <v-row
    no-gutters
    justify="center"
    align="stretch"
    class="intervention-search-result-item"
    @click="$emit(`click`)"
    @mouseenter="$emit(`mouseenter`)"
  >
    <div class="d-flex flex-column search-result-left">
      <div class="flex-grow-1 id">#{{ intervention.displayNum }}</div>
      <div class="flex-grow-1 client ellipsis">
        <template v-if="company.isRoot">
          {{ intervention.client.name }}
        </template>
        <template v-else>
          {{ intervention.maker.name }}
        </template>
      </div>
      <div class="flex-grow-1 status ellipsis" :style="{ 'background-color' : intervention.status.color, color: statusFontColor(intervention.status) }">
        {{ intervention.status.name }}
      </div>
    </div>
    <v-col class="d-flex flex-column search-result-right">
      <div class="flex-grow-1 description">
        <v-clamp autoresize :max-lines="2">
          {{ intervention.$title }}
        </v-clamp>
      </div>
      <div class="subtitle">Créée le {{ intervention.$createdAt }} par {{ intervention.user.firstname }} {{ intervention.user.lastname }}</div>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapState } from 'vuex';

export default {
  name: `InterventionResultItem`,
  props: [`value`],
  computed: {
    ...mapState(`model/client`, [
      `company`,
    ]),
    ...mapGetters(`model/intervention`, [
      `statusFontColor`,
    ]),
    intervention() {
      const $title = this.value.description
        .replace(/\r\n|\r|\n/g, ``)
        .replace(/(.)(<br \/?>)+/g, this.breakLineTitleReplacer);
      const $createdAt = moment(this.value.createdAt).format(`DD/MM/YYYY [à] HH[h]mm`);
      return {
        ...this.value,
        $title,
        $createdAt,
      };
    },
  },
  methods: {
    breakLineTitleReplacer(match, char) {
      let res = char;
      if (char.match(/\w/g) !== null) {
        res = `${res}.`;
      }
      return `${res} `;
    },
  },
};
</script>

<style lang="scss" scoped>
  .intervention-search-result-item {
    padding: 0.8rem 0;
  }
  .search-result-left {
    width: 170px;
    // padding: 0.6rem 0;
    margin-right: 10px;
    .id,
    .client,
    .status {
      text-align: center;
    }
    .id {
      font-size: 0.9rem;
      font-weight: 500;
      padding-bottom: 0.1rem;
    }
    .client {
      font-size: 0.9rem;
      color: #555;
      padding: 0.1rem 0.2rem;
    }
    .status {
      margin-top: 0.1rem;
      background-color: #06d006;
      color: #FFF;
      border-radius: 0px 15px 15px 0px;
      font-size: 0.8rem;
      font-weight: 500;
      padding: 5px 6px;
    }
  }
  .search-result-right {
    .description {
      font-size: 0.9rem;
      font-weight: 500;
      color: #444;
      padding-right: 0.4rem;
    }
    .subtitle {
      font-size: 0.7rem;
      font-style: italic;
      margin-bottom: 0.3rem;
      color: #666;
    }
  }
</style>
